import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { UploadResponse } from '../../../models/shared-component/upload-response';
import { FileService } from '../../../services/file.service';

@Component({
  selector: 'app-master-attachment',
  templateUrl: './master-attachment.component.html',
  styleUrls: ['./master-attachment.component.scss']
})
export class MasterAttachmentComponent implements OnChanges {

  @Input() title: string;
  @Input() form: FormGroup;
  @Input() formArray: FormArray;
  @Input() formArrayName: string;
  @Input() record$: BehaviorSubject<FormArray>;
  @Input() isDisabled: boolean;

  constructor(private fileService: FileService, private fb: FormBuilder) { }

  ngOnChanges(changes: SimpleChanges): void { }

  onFileChange(event: any): void {
    const file: File = event.target.files[0];
    this.fileService.upload(file).subscribe((res: UploadResponse) => {
      this.formArray.push(
        this.fb.group({
          originalFileName: [res.originalFileName],
          generateFileName: [res.generatedFileName],
          fileSize: [res.fileSize],
          fileExtension: [res.fileExtension],
        })
      );
      this.record$.next(this.formArray);
    });
  }

  onDownloadFile(generateFileName: string, fileExtension: string, originalFileName: string): void {
    if (!generateFileName) {
      alert("ไม่พบเนื้อไฟล์");
      return;
    }
    this.fileService.download(generateFileName, fileExtension).subscribe({
      next: (blob: Blob) => {
        const objectUrl = window.URL.createObjectURL(blob);
        if (fileExtension?.toLowerCase() === '.pdf') {
          // คง behavior เดิม: PDF เปิดพรีวิวใน tab ใหม่ ไม่ใช่โหลดลงเครื่อง
          window.open(objectUrl);
        } else {
          const a = document.createElement('a');
          a.href = objectUrl;
          a.download = originalFileName || `${generateFileName}${fileExtension}`;
          a.click();
        }
        // หน่วง revoke เพราะ tab/ดาวน์โหลดยังอ่าน object URL อยู่ตอน click
        setTimeout(() => window.URL.revokeObjectURL(objectUrl), 60000);
      },
      error: () => alert("ไม่พบเนื้อไฟล์"),
    });
  }
}
